import { baseUrl } from '@/service/util';
import request from '@/utils/request';
import { setLocaleQuery } from '@/utils';
import { CookieDataExtendType } from 'eco-design-reliance/cookies/type.d';
import { subscribeCookie } from 'eco-design-reliance/cookies/subscribeCookie';

// tease预热
// 获取订阅人数
export const getSubscribeNumber = (locale: string) => {
    return request.get(`${baseUrl(locale)}/deltaProUltra/subscribeNum${setLocaleQuery(locale)}`);
};

// 提交邮箱订阅
export const submitScribe = (locale: string, data: any, subscribeData?: CookieDataExtendType) => {
    if (['jp'].includes(locale)) {
        return request.post(`${baseUrl(locale)}/subscribe/shopify${setLocaleQuery(locale)}`, {
            data: subscribeData ? { ...data, eventTracking: subscribeCookie(subscribeData) } : data,
        });
    }
    return request.post(`${baseUrl(locale)}/deltaProUltra/subscribe${setLocaleQuery(locale)}`, {
        data: subscribeData ? { ...data, eventTracking: subscribeCookie(subscribeData) } : data,
    });
};

// Join now
export const submitJoin = (locale: string, data: any) => {
    return request.post(`${baseUrl(locale)}/deltaProUltra/webClick${setLocaleQuery(locale)}`, { data });
};

// pre-launch页
export const getCoupounInventory = (locale: string) => {
    return request.get(`${baseUrl(locale)}/deltaProUltra/dpuProductOfCoupons`);
};

// 查询邮编
export const getCheckZipCode = (locale: string, zipCode: any) => {
    return request.get(`${baseUrl(locale)}/electricianScope/checkZipCode?zipCode=${zipCode}`);
};
